module.exports = __webpack_public_path__ + "static/media/arrow-left.995bdd08.svg";